<ul class="c-list">
	<li class="c-list__item" [ngClass]="{'u-osb-sm': !$last}" *ngFor="let stat of vm.stats ; let $last = last">
		<div class="o-grid">
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
				<i class="o-icon o-icon--{{ stat.icon }} c-list__icon" aria-hidden="true"></i>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fit">
				<p class="c-text c-text--spaced c-text--gray u-no-m">{{ stat.label }}</p>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
				<p class="c-text c-text--spaced c-text--right c-text--bold c-text--main u-no-m">{{ stat.value || 0 }}</p>
			</div>
		</div>
	</li>
</ul>
